<template>
  <div id="app">
    <router-view ref="app" />
    <notifications position="bottom center"> </notifications>
  </div>
</template>
<script>
export default {
  mounted() {
    window.$vm = this.$refs.app;
  }
};
</script>
